import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { FHEContainer, FHEContainerScroll, FHETitle } from 'data/components';
import { SvgCraftsman } from 'data/common/iconsvg';
import FormInstaller from './Form/FormInstaller';
import { addInstaller } from '../../data/Installers/actions';

class InstallerAdd extends PureComponent {
    static propTypes = {
        addInstaller: PropTypes.func.isRequired
    };
    render() {
        const { addInstaller } = this.props;
        return (
            <FHEContainer withBackIcon>
                <FHETitle title={Translator.translate('general.addInstaller')} Icon={SvgCraftsman} />
                <FHEContainerScroll>
                    <FormInstaller type="add" sendDataFunc={addInstaller} />
                </FHEContainerScroll>
            </FHEContainer>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { addInstaller }), dispatch)
    )(InstallerAdd)
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Installer/add.js